import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';

import { Table, Statistic, Row, Col } from 'antd';

class TrafficSignsInfosTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {}
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={6}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Verze firmware"
              value={record.info.firmware} />
          </Col>
          <Col span={6}>
            <Statistic
              formatter={(value) => { return value; }}
              title="IMEI"
              value={record.info.imei} />
          </Col>
          <Col span={6}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Síť"
              value={record.info.network} />
          </Col>
          <Col span={6}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Číslo SIM"
              value={record.info.sim} />
          </Col>
        </Row>
      </div >
    );
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Seriové číslo',
      dataIndex: 'serialNumber',
      key: 'serialNumber',
      width: 150,
      sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber),
    }, {
      title: 'Popis',
      dataIndex: 'description',
      key: 'description',
      width: 500,
    }, {
      title: 'IMEI',
      dataIndex: 'info.imei',
      key: 'info.imei',
      // sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber),
    }, {
      title: 'Čas',
      dataIndex: 'createdAt',
      key: 'createdAt',
      defaultSortOrder: 'descend',
      sorter: (a, b) => dateSorter(a.createdAt, b.createdAt),
      render: (text, record) => (
        <span>{text ? moment(text).format('L LTS') : null}</span>
      ),
    }]

    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={columns}
        dataSource={this.props.data}
        style={{ border: '0px' }}
        onChange={this.handleChange}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        expandedRowRender={this.expandedRowRender.bind(this)} />
    );
  }
}

export default TrafficSignsInfosTable;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsInfosTable.js